export const MISSED_PING_THRESHOLD_TIME: number = 60 * 1000; // 1 minute - we get server pings at every 60 secs and debounce is of 5 secs
export const THROTTLE_TIMEOUT = 10 * 1000; // 10 secs
export const ONE_MINUTE = 60 * 1000;
export const PING_RESPONSE_TIMEOUT = 10 * 1000;
